import _ from "lodash";
import * as types from "../types/rlab-types";

export const generateVariants = options => {
  const { api, page } = options;
  return {
    asyncAction: () =>
      api
        .generateVariants({ page })
        .then(response => {
          if (typeof FS === 'function') {
            try {
              for (let experiment in response) {
                FS('trackEvent', {
                  name: "Experiment Viewed",
                  properties: {
                    experiment_id: experiment,
                    variation_id: response[experiment],
                    experiment_page: page
                  }
                });
              }
            } catch (err) {
              console.error("Error tracking experiment", err);
            }
          }
          return response;
        })
        .catch(error => {
          //use error code that doesn't route
          throw { code: "GENERATE_VARIANTS_ERROR" };
        }),
    type: types.GENERATE_VARIANTS
  };
};

export const generateVariantsAuthenticated = (options, loanId) => {
  const { api, page } = options;
  return {
    asyncAction: () =>
      api
        .generateVariantsAuthenticated({ page }, loanId)
        .then(response => {
          return response;
        })
        .catch(error => {
          //use error code that doesn't route
          throw { code: "GENERATE_VARIANTS_ERROR" };
        }),
    type: types.GENERATE_VARIANTS
  };
}

export const reset = () => {
  return {
    type: types.GENERATE_VARIANTS_RESET
  };
};
